<template>
    <ProfileOptionSelector :model="'job'" :nextRoute="() => 'HeightPage'" />
</template>

<script>
export default {
    name: 'JobPage',
}
</script>
